import { createReducer, on } from '@ngrx/store';
import * as actions from './subscription-discounts.actions';
import { SubscriptionDiscounts } from '../types/subscription-discounts';

export const subscriptionDiscountsFeatureKey = 'subscriptionDiscounts';
export interface State {
  isLoading: boolean;
  isLoaded: boolean;
  discounts: SubscriptionDiscounts;
}

export const initialState: State = {
  isLoading: false,
  isLoaded: false,
  discounts: null,
};

export const reducer = createReducer(
  initialState,
  on(actions.getSubscriptionDiscounts, state => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getSubscriptionDiscountsSuccess, (state, action) => ({
    ...state,
    isLoading: false,
    isLoaded: true,
    ...action,
  })),
  on(actions.getSubscriptionDiscountsFailure, state => ({
    ...state,
    isLoading: false,
  })),
);
